<div class="d-flex h-100 align-items-center justify-content-center">
    <div class="blinker blinker-xl" role="status">Loading...</div>
</div>

